<template>
  <div class="previews-page">
    <JobDetailRender
      v-if="!showPCPreview"
      class="mobile-previewer"
      isPreview
      :jobDetailInfo="jobDetailInfo"
      :jobAndCompanyInfo="jobAndCompanyInfo"
      :showApply="!!showApply"
      :aboutUsPreview="aboutUsPreview"
      :hasCustomMobileLandingPage2="hasCustomMobileLandingPage2"
      :hasCustomMobileLandingPage="hasCustomMobileLandingPage"
      :previewWebpagItem="previewWebpageItem"
      :updateTime="updateTime"
      :groupName="groupName"
      @closePreview="handleClosePreview"
      @changeDevice="handleChangeDevice"
    />
    <EditorPCPreview
      v-if="showPCPreview"
      class="pc-previewer"
      :jobDetailInfo="jobDetailInfo"
      :jobId="jobDetailInfo.id"
      :companyId="jobDetailInfo.company.id"
      :jobAndCompanyInfo="jobAndCompanyInfo"
      :companyDetailInfo="companyInfo"
      @closePreview="handleClosePreview"
      @changeDevice="handleChangeDevice"
    />
  </div>
</template>

<script>
import _ from 'lodash'
import { isEn, addI18nProperty } from '@/i18n'
import JobDetailRender from '@/components/job/jobDetail/JobDetailRender.vue'
import EditorPCPreview from './editorPCPreviewNew.vue'
import { mapActions } from 'vuex'

const ROLE_TYPE_MAP = {
  F: 'FULL_TIME',
  P: 'PART_TIME',
  I: 'INTERNSHIP'
}

export default {
  components: {
    JobDetailRender,
    EditorPCPreview
  },
  metaInfo () {
    return {
      style: this.metaInfoStyleList
    }
  },
  data () {
    return {
      showPCPreview: true,
      updateTime: '',
      jobDetailInfoResp: {},
      metaInfoStyleList: [],
      pcPreviewWebpageItem: [],
      mobilePreviewWebpageItem: [],
      previewInfo: null,
      jobLocationList: null,
      showApply: false,
      to_show_referral: null,
      companyPolicyInfo: {
        id: null,
        type: null,
        html_content: null
      },
      need_statement_2: null,
      needStatement: null,
      webpage_item: null,
      aboutUsPreview: 'about_us',
      hasCustomMobileLandingPage2: false,
      hasCustomMobileLandingPage: false,
      groupName: '',
      refStepsSetting: null,
      isCompanyEmployee: false,
      isFosunCompany: false,
      jobDetailHasRewardsRules: false,
      customizationRewardsRules: null,
      jobAndCompanyInfo: {},
      companyInfo: {}
    }
  },
  props: {
    jobDetailInfo: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    languageCode () {
      return this.$i18n.locale
    },
    previewWebpageItem () {
      if (this.showPCPreview) {
        return this.pcPreviewWebpageItem
      } else {
        return this.mobilePreviewWebpageItem
      }
    }
  },
  created () {
    this.initJobCustomHeaderAndFooter()
    this.initCustomInfo()
    this.initPage()
    if (this.jobDetailInfo.short_unique_id) {
      this.initInfo()
    } else {
      this.setJobBaseInfo()
    }
    this.hiddenAsideMenu()
  },
  mounted () {
    window.onbeforeunload = this.handleWindowBeforeUnload
  },
  beforeDestroy () {
    window.onbeforeunload = null
    this.showAsideMenu()
  },
  methods: {
    ...mapActions('company', ['getCustomJobDetailPageInfo']),
    ...mapActions('job', [
      'getJobApplyAgreementInfo',
      'getJobApplyStatus',
      'getJobReferralSetting',
      'getJobDetailInfoByShortId'
    ]),
    hiddenAsideMenu () {
      if (document.getElementsByClassName('aside-icon-menu').length) {
        document.getElementsByClassName('aside-icon-menu')[0].style.display = 'none'
      }
      if (document.getElementsByClassName('root-layout').length) {
        document.getElementsByClassName('root-layout')[0].style.paddingLeft = '0px'
      }
    },
    showAsideMenu () {
      if (document.getElementsByClassName('aside-icon-menu').length) {
        document.getElementsByClassName('aside-icon-menu')[0].style.display = 'block'
      }
      if (document.getElementsByClassName('root-layout').length) {
        document.getElementsByClassName('root-layout')[0].style.paddingLeft = '56px'
      }
    },
    handleClosePreview () {
      this.$emit('closePreview')
    },
    handleChangeDevice () {
      this.showPCPreview = !this.showPCPreview
      this.initCustomInfo()
    },
    initJobCustomHeaderAndFooter () {
      const vm = this
      Object.defineProperty(this.jobDetailInfo, 'customized_header_cn', {
        configurable: true,
        enumerable: true,
        get () {
          return vm.showPCPreview ? vm.jobDetailInfo.pc_customized_header_cn : vm.jobDetailInfo.mobile_customized_header_cn
        }
      })
      Object.defineProperty(this.jobDetailInfo, 'customized_footer_cn', {
        configurable: true,
        enumerable: true,
        get () {
          return vm.showPCPreview ? vm.jobDetailInfo.pc_customized_footer_cn : vm.jobDetailInfo.mobile_customized_footer_cn
        }
      })
      Object.defineProperty(this.jobDetailInfo, 'customized_header_en', {
        configurable: true,
        enumerable: true,
        get () {
          return vm.showPCPreview ? vm.jobDetailInfo.pc_customized_header_en : vm.jobDetailInfo.mobile_customized_header_en
        }
      })
      Object.defineProperty(this.jobDetailInfo, 'customized_footer_en', {
        configurable: true,
        enumerable: true,
        get () {
          return vm.showPCPreview ? vm.jobDetailInfo.pc_customized_footer_en : vm.jobDetailInfo.mobile_customized_footer_en
        }
      })
    },
    async initCustomInfo () {
      const resp = await this.getCustomJobDetailPageInfo({
        company_id: this.jobDetailInfo.company.id,
        is_mobile: !this.showPCPreview
      })
      if (resp) {
        this.aboutUsPreview = resp.about_us
        this.hasCustomMobileLandingPage2 = resp.has_custom_mobile_landing_page_2
        this.hasCustomMobileLandingPage = resp.has_custom_mobile_landing_page
        this.groupName = resp.group
        if (this.jobDetailInfo.enable_company_job_customization && resp.webpage_item && resp.webpage_item.length > 0) {
          this.mobilePreviewWebpageItem = JSON.parse(resp.webpage_item)
          this.setJobWebpageInfo({
            en: JSON.parse(resp.webpage_item),
            zh: JSON.parse(resp.webpage_item)
          })
        } else {
          this.setJobWebpageInfo()
          this.mobilePreviewWebpageItem = []
        }
        if (this.jobDetailInfo.enable_company_job_customization && resp.button_items?.length) {
          this.setCustomJobButtonSettings({
            zh: resp.button_items,
            en: resp.button_items
          })
        }
      }
    },
    handleWindowBeforeUnload ($event) {
      if (this.jobDetailInfo.hasUnsavedData) {
        return ''
      } else {
        window.onbeforeunload = null
      }
    },
    initPage () {
      const styleList = []
      styleList.push(`
        #main a {
          cursor: default;
        }
        #main .agree #tos_check_error {
          display: block;
        }
        #main .mobile-previewer #referral-icon {
          left: 50%;
          -webkit-transform: translate(104.5px, 0);
                  transform: translate(104.5px, 0);
        }
        #main .mobile-previewer #referral-submit-info {
          display: block;
        }
        #main .mobile-previewer #referral-share-confirm .confirm-message-div.jd-or-width {
          width: initial;
        }
        #main .mobile-previewer #referral-rewards-info {
          display: block;
        }
        #main .mobile-previewer #job-detail-map-container .icon-close {
          width: 32px;
          height: 32px;
        }
        #main .mobile-previewer #earn-rewards-btn, #main .mobile-previewer #earn-up-btn, #main .mobile-previewer #apply-directly {
          height: 30px;
          line-height: 30px;
          border-radius: 20px;
          padding: 5px 0;
          -webkit-box-sizing: content-box;
                  box-sizing: content-box;
        }
        #main .mobile-previewer #earn-up-btn .btn1, #main .mobile-previewer #apply-directly .btn1 {
          font-size: 18px;
        }
        #main .mobile-previewer .apply-job-success-wrapper .btn-group {
          padding: 0px 0 10px;
          padding-bottom: calc(10px + env(safe-area-inset-bottom));
        }
        #main .mobile-previewer .job-detail-wrapper .responsibility-request {
          line-height: 20px;
        }
        #main .mobile-previewer .job-detail-wrapper li.list-style-decimal {
          margin: 0 17px;
        }
        #main .mobile-previewer .job-detail-wrapper .btn-group {
          padding: 5px 0 10px;
          width: 373px;
          padding-bottom: calc(10px + env(safe-area-inset-bottom));
          z-index: 0;
          position: absolute;
        }
        #main .mobile-previewer .job-detail-wrapper .btn-group .btn-inner {
            width: 300px;
            height: auto;
        }
        #main .mobile-previewer .btn-group .agree label {
          font-size: 14px;
        }
        #main .mobile-previewer .agree .checkbox {
          width: 15px;
          height: 15px;
          margin-right: 10px
        }
        #main .mobile-previewer .submit-btn {
          bottom: 0;
        }
        #main .mobile-previewer .referral-wrapper .job-content {
          padding-bottom: 120px;
        }
        #main .mobile-previewer .referral-wrapper .powered-by {
          line-height: 13px;
          padding-bottom: 0;
          text-align: center;
          font-size: 12px;
          margin-top: 15px;
        }
        #main .mobile-previewer .referral-wrapper .responsibility-request {
          min-height: 120px;
        }
        #main .mobile-previewer .powered-by {
          font-size: 12px;
        }
        #main .mobile-previewer .powered-by .icon {
          width: 18px;
          height: 13px;
        }
        #main.page-en .mobile-previewer .job-detail-wrapper .job-intro label {
          font-size: 14px;
          width: 100px;
        }
        #main.page-en .edit-preview .job-detail .job-intro p label {
          min-width: 130px
        }
        #main .mobile-previewer .job-detail-wrapper .responsibility-request {
          padding: 20px;
        }
        #main .mobile-previewer .job-detail-wrapper .responsibility-request ol {
          font-size: 13px;
        }
        #main .job-detail-wrapper .responsibility-request ul {
          font-size: 13px;
        }
        .header .navigation .navigation-item span, .header .navigation .navigation-item div{
          font-size: 12px;
        }
        .body {
          background-color: #fff;
        }
        .footer .common-footer div {
          font-size: 12px;
        }
        a {
          color: #0096cc;
        }
      `)
      const metaInfoStyleList = [
        {
          innerHTML: styleList.join('\n')
        }
      ]
      this.metaInfoStyleList = metaInfoStyleList
    },
    async getJobDetailInfo () {
      const resp = await this.getJobDetailInfoByShortId({
        shortId: this.jobDetailInfo.short_unique_id,
        params: {
          is_preview: true,
          enable_custom_job_detail_company_level: this.jobDetailInfo.enable_company_job_customization
        }
      })
      if (!resp) {
        this.$message.error(this.$t('error.message.serverError'))
        return
      }
      this.jobAndCompanyInfo = resp.data || {}
      this.companyInfo = resp.data?.company || {}
      this.updateTime = resp.data.job.updated_time
      this.isFosunCompany = resp.data.job.is_fosun_company
      this.isCompanyEmployee = resp.data.job.isEmployeeOfCompany
      this.jobDetailHasRewardsRules = resp.data.job_detail_has_rewards_rules
      this.customizationRewardsRules = resp.data.customization_rewards_rules
      this.jobDetailInfo.company_job_filters = resp.data.job.company_job_filters || []
      const customFieldsValueMap = {}
      const customFieldsItemValueMap = {}
      _.forEach(this.jobDetailInfo.custom_fields, (item) => {
        customFieldsValueMap[item.id] = item.filter_value
        customFieldsItemValueMap[item.id] = item.filter_value_items
      })
      this.jobDetailInfo.custom_fields = _.map(resp.data.job.custom_fields, item => {
        return {
          ...item,
          filter_value: customFieldsValueMap[item.id],
          filter_value_items: customFieldsItemValueMap[item.id] || []
        }
      }) || []
      if (!_.has(this.jobDetailInfo.work_time, 'item')) {
        if (this.jobDetailInfo.work_time.id === -1) {
          this.jobDetailInfo.work_time.item = {
            cn_name: '不限',
            en_name: 'Not Specified'
          }
        } else {
          this.jobDetailInfo.work_time.item = {
            cn_name: resp.data.job.work_time.cn_name,
            en_name: resp.data.job.work_time.en_name
          }
        }
      }
      if (!_.has(this.jobDetailInfo.compensation, 'item')) {
        this.jobDetailInfo.compensation.item = {
          cn_name: resp.data.job.compensation.cn_name,
          name: resp.data.job.compensation.en_name
        }
      }
      if (this.jobDetailInfo.enable_company_job_customization && resp.data.job?.all_webpage_item) {
        this.pcPreviewWebpageItem = _.get(resp.data.job.all_webpage_item, isEn() ? 'en' : 'zh')
      } else {
        this.pcPreviewWebpageItem = []
      }
      if (this.companyInfo) {
        addI18nProperty(this.companyInfo, 'i18nName', 'cn_name', 'name')
      }
      if (this.jobDetailInfo) {
        this.jobDetailInfo.roleType = ROLE_TYPE_MAP[this.jobDetailInfo.role_type]
        addI18nProperty(this.jobDetailInfo, 'i18nName', 'cn_title', 'title')
        if (this.jobDetailInfo.job_locations) {
          _.forEach(this.jobDetailInfo.job_locations, (item) => {
            if (item.city) {
              addI18nProperty(item.city, 'i18nName', 'cn_name', 'name')
            }
            if (item.region) {
              addI18nProperty(item.region, 'i18nName', 'cn_name', 'name')
            }
            if (item.cbd) {
              addI18nProperty(item.cbd, 'i18nName', 'cn_name', 'name')
            }
          })
          this.jobLocationList = this.jobDetailInfo.job_locations
        }

        this.setJobBaseInfo()

        if (resp.data.job?.all_webpage_item) {
          this.$set(this.jobDetailInfo, 'all_webpage_item', {
            en: resp.data.job.all_webpage_item?.en || [],
            zh: resp.data.job.all_webpage_item?.zh || []
          })
        }

        if (this.jobAndCompanyInfo.jd_customize) {
          this.setJobWebpageInfo(resp.data.job.all_webpage_item)
          this.setCustomJobButtonSettings(resp.data.job.all_button_items)
        }
      }
    },
    setJobWebpageInfo (webpageInfo) {
      this.$set(this.jobDetailInfo, 'all_webpage_item', {
        en: null,
        zh: null
      })
      if (!webpageInfo) {
        webpageInfo = {
          en: [],
          zh: []
        }
      }
      let webpageItemEn = webpageInfo?.en || []
      let webpageItemCn = webpageInfo?.zh || []
      const customizedHeaderEn = this.jobDetailInfo.customized_header_en ? JSON.parse(this.jobDetailInfo.customized_header_en) : null
      const customizedHeaderCn = this.jobDetailInfo.customized_header_cn ? JSON.parse(this.jobDetailInfo.customized_header_cn) : null
      const customizedFooterEn = this.jobDetailInfo.customized_footer_en ? JSON.parse(this.jobDetailInfo.customized_footer_en) : null
      const customizedFooterCn = this.jobDetailInfo.customized_footer_cn ? JSON.parse(this.jobDetailInfo.customized_footer_cn) : null

      if (webpageItemEn.length === 1 && webpageItemEn[0].type === 'job-detail-description') {
        webpageItemEn = []
      }

      if (webpageItemCn.length === 1 && webpageItemCn[0].type === 'job-detail-description') {
        webpageItemCn = []
      }

      if (webpageItemEn?.length) {
        if (customizedHeaderEn) {
          const headerIndex = _.findIndex(webpageItemEn, item => item.type === 'job-detail-description')
          webpageItemEn.splice(headerIndex, 0, ...customizedHeaderEn)
        }
        if (customizedFooterEn) {
          const footerIndex = _.findIndex(webpageItemEn, item => item.type === 'job-detail-description')
          webpageItemEn.splice(footerIndex + 1, 0, ...customizedFooterEn)
        }
      } else {
        if (customizedHeaderEn) {
          webpageItemEn.push(...customizedHeaderEn)
        }
        webpageItemEn.push({ type: 'job-detail-description' })
        if (customizedFooterEn) {
          webpageItemEn.push(...customizedFooterEn)
        }
      }

      if (webpageItemCn?.length) {
        if (customizedHeaderCn) {
          const headerIndex = _.findIndex(webpageItemCn, item => item.type === 'job-detail-description')
          webpageItemCn.splice(headerIndex, 0, ...customizedHeaderCn)
        }
        if (customizedFooterCn) {
          const footerIndex = _.findIndex(webpageItemCn, item => item.type === 'job-detail-description')
          webpageItemCn.splice(footerIndex + 1, 0, ...customizedFooterCn)
        }
      } else {
        if (customizedHeaderCn) {
          webpageItemCn.push(...customizedHeaderCn)
        }
        webpageItemCn.push({ type: 'job-detail-description' })
        if (customizedFooterCn) {
          webpageItemCn.push(...customizedFooterCn)
        }
      }
      this.$set(this.jobDetailInfo, 'all_webpage_item', {
        en: webpageItemEn,
        zh: webpageItemCn
      })
    },
    setJobBaseInfo () {
      if (this.jobDetailInfo.work_time) {
        if (this.jobDetailInfo.work_time.id === -1) {
          this.jobDetailInfo.work_time.item = {
            cn_name: '不限',
            en_name: 'Not Specified'
          }
          return
        }

        this.$set(this.jobDetailInfo.work_time, 'cn_name', this.jobDetailInfo.work_time.item.cn_name)
        this.$set(this.jobDetailInfo.work_time, 'en_name', this.jobDetailInfo.work_time.item.en_name)
      }
      if (this.jobDetailInfo.compensation) {
        this.$set(this.jobDetailInfo.compensation, 'cn_name', this.jobDetailInfo.compensation.item.cn_name)
        this.$set(this.jobDetailInfo.compensation, 'en_name', this.jobDetailInfo.compensation.item.name)
      }
    },
    setCustomJobButtonSettings (buttonSettingsInfo) {
      this.$set(this.jobDetailInfo, 'all_button_items', {
        en: buttonSettingsInfo.en || [],
        zh: buttonSettingsInfo.zh || []
      })
    },
    async initInfo () {
      const params = { short_id: this.jobDetailInfo.short_unique_id, refer_id: '' }
      await this.getJobApplyStatus(params).then(resp => {
        if (resp) {
          this.showApply = resp.show_apply
        }
      })
      this.getJobDetailInfo()
      await this.initJobApplyAgreement()
      this.initReferralSetting()
    },
    async initJobApplyAgreement () {
      if (!this.jobDetailInfo.short_unique_id) {
        return
      }
      const params = { short_id: this.jobDetailInfo.short_unique_id, refer_id: '' }
      this.getJobApplyAgreementInfo(params).then(companyPolicyInfo => {
        if (!companyPolicyInfo) {
          this.need_statement_2 = false
          this.needStatement = false
        } else {
          if (companyPolicyInfo.type === 'POPUP') {
            this.needStatement = true
          } else {
            this.need_statement_2 = true
          }
          this.companyPolicyInfo = companyPolicyInfo
        }
      })
    },
    async initReferralSetting () {
      const resp = await this.getJobReferralSetting({
        short_id: this.jobDetailInfo.short_unique_id
      })
      this.to_show_referral = resp.to_show_referral
      this.refStepsSetting = resp.ref_steps_setting
    }
  },
  watch: {
    languageCode () {
      this.initJobApplyAgreement()
      this.initCustomInfo()
    }
  }
}
</script>

<style lang="scss" scoped>
.previews-page {
  margin-top: -20px;
  margin-right: -20px;
}

.mobile-previewer {
    border: 1px solid #ccc;
    width: 375px;
    min-height: 716px;
    margin: auto;
    margin-top: 0;
    background-color: #fff;
    position: relative;

    ::v-deep .custom-header {

      .header-title {
        height: 63px;
      }

      .header-main {
        display: flex;
        height: auto;
        .logo {
          float: none;
        }
        .message {
          float: none;
          max-width: none;
          flex: 1;
          font-size: 14px;

          .job-name {
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            white-space: initial;
          }
        }
      }

      .header-menu {
        a {
          font-size: 16px;
        }

      }
    }
    ::v-deep #job-detail-information-contanier {
      .job-intro {
        font-size: 14px;
        padding: 15px 0;
        margin: 0 20px;

        p > label {
          color: #666;
          display: inline-block;
          width: 80px;
          padding: 5px 0;
          font-size: 14px;
        }
        span {
          display: inline-block;
          font-size: 14px;
        }
        .all-locations {
          right: 0;
        }
      }
      .job_location {
        font-size: 14px;

        .job-location-field > ul > li {
          font-size: 14px;
        }

        label {
          font-size: 14px;
          width: 80px;
          padding: 5px 0;
        }

        .location {
          font-size: 22px;
          color: #666;
          position: absolute;
          top: 0;
          right: 0;

          .icomoon-location {
            font-size: 20px;
          }
        }
      }

      .company-survey-entrance {
        font-size: 20px;
        float: right;

        span {
          font-size: 20px;
        }
      }
    }
    .pop-tip-bottom {
      .referral-tip-message {
        font-size: 12px;
        margin-top: 20px;
      }
    }
    .jd-submit-padding {
      padding-top:3px
    }
    .jd-submit-margin-top {
      margin-top: -4px;
    }
    .share-link-container {
      .share-link-btn {
        margin-left:30%
      }
    }
    .jd-map-container {
      position: absolute;
      bottom: 0;
      top:0;
      z-index: 100;
      width: 100%;
    }
    .no-custom-landing-page-navbar {
      .navbar {
        z-index: 2000;
      }
    }
    .powered-by {
      padding-bottom: 80px;
    }
    #wechat-popup {
      padding: 1px;
      #mask {
        display: block;
      }
      #referral-transition {
        display: block;
        transform: translate(-50%, -50%);
        position: absolute;
        top: 50vh;
        left: 50%;
        .share-job-poster {
          border: 0;
          padding-bottom: 8%;
          .poster-tip-container {
            display: flex;
            padding: 10px 15px;
            box-sizing: border-box;
            justify-content: space-between;
          }
          .poster-preview {
            width: 100%;
            overflow: hidden;
            display: flex;
            justify-content: space-around;
            align-items: center;
            padding: 0 10px;
            box-sizing: border-box;
            height: 190px;
            &-container {
              display: flex;
              flex-direction: column;
              justify-content: space-around;
              align-items: center;
              height: 100%;
              .image-container {
                display: flex;
                justify-content: center;
                align-items: center;
                border-radius: 8px;
                // border: solid 1px #DCDCDC;
                // padding: 10px;
                box-sizing: border-box;
                height: 150px;
                .image-wrapper {
                  height: 100%;
                  position: relative;
                  display: flex;
                  .image-overlay {
                    position: absolute;
                    top: 0;
                    left: 0;
                    right: 0;
                    bottom: 0;
                    z-index: 1;
                  }
                  img {
                    max-height: 100%;
                    max-width: 100%;
                    border-radius: 8px;
                    object-fit: contain;
                  }
                }
                .icon-video-play {
                  width: 35px;
                  height: 35px;
                  position: absolute;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                  z-index: 1;
                  > div {
                    width: 100%;
                    height: 100%;
                    border-radius: 50%;
                    background: rgba($color: #000000, $alpha: 0.6);
                  }
                  img {
                    position: absolute;
                    width: 100%;
                  }
                }
              }
              .share-btn {
                width: 60px;
                height: 20px;
                border-radius: 10px;
                display: flex;
                align-items: center;
                justify-content: center;
                font-size: 12px;
                color: white;
              }
              .save-video-tip {
                height: 30px;
                padding-top: 10px;
                font-size: 12px;
                display: flex;
                justify-content: center;
                align-items: center;
                text-align: center;
              }
            }
          }
        }
        .refer-share-to {
          padding-bottom: 0;
        }
        .share-content {
          padding-bottom: 5px;
        }

      }
      #wechat-pointer {
        display: block;
      }
      #qrcode-transition {
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        display: block;
        .qrcode-content {
          display: block;
        }
      }
      #single-job-group-popup {
        display: block;
      }
      #transition {
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
        display: block;
      }
      #wechat-share-tip {
        display: block;
      }
      .poster-transition {
        position: fixed;
        z-index: 10001;
        width: 100%;
        height: 100%;
        top: 0px;
        overflow: scroll;
        .poster-img {
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          align-items: center;
          z-index: 10001;
          img {
            -webkit-touch-callout: default;
            width: 90%;
          }
          video {
            width: 90%;
          }
          margin-top: 5vw;
          max-height: 68%;
          overflow: scroll;
        }
        .poster-close-btn {
          z-index: 10002;
          background: none;
          position: absolute;
          right: 1%;
          top: 1%;
          color: white;
          i {
            width: 32px;
            height: 32px;
            display: block;
            font-size: 220%;
          }
        }
        img {
          width: 100%;
        }
        .save-video-tip-pop {
          margin: 50px auto;
          margin-top: 20px;
          color: white;
          width: 90vw;
          text-align: center;
          padding-bottom: 20%;
          .generate-video-loading {
            width: 100%;
            height: 50px;
            position: relative;
            z-index: inherit;
          }
          .save-video-text {
            font-size: large;
            line-height: 22px;
          }
          .download-text {
            // margin-top: 30px;
            font-size: large;
            color: white;
            > span {
              margin-left: 7px;
              font-size: large;
              font-weight: bold;
            }
          }
          .download-image {
            width: 40vw;
            margin: 20px auto;
            span {
              font-size: 100px;
            }
          }
        }
        .wechat-download-tip {
          position: absolute;
          top: 0;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          width: 100vw;
          height: 100vh;
          left: 0;
          overflow: scroll;
          background: rgba($color: #000000, $alpha: 0.75);
          img {
            width: 100%;
          }
          .got-it-container {
            position: relative;
            left: 15vw;
            width: 80px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            .got-it-text {
              position: absolute;
              color: white;
              margin: 0;
              width: 100%;
              display: flex;
              justify-content: center;
              align-items: center;
            }
          }
        }
      }
      .save-img-tip {
        box-sizing: border-box;
        padding: 25px;
        color: white;
        text-align: center;
        width: 80%;
        position: fixed;
        left: 10%;
        z-index: 10002;
        > span {
          font-size: large;
          line-height: 22px;
        }
      }
      .bottom-poster-list-content::-webkit-scrollbar {
        display: none;
      }
      .bottom-poster-list {
        box-sizing: border-box;
        padding: 20px;
        width: 100%;
        height: 15vh;
        background: white;
        border-radius: 8px 8px 0 0;
        position: fixed;
        bottom: 0;
        left: 0;
        .bottom-poster-list-content {
          width: 100%;
          height: 100%;
          overflow-x: scroll;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          > :not(:last-child) {
            margin-right: 15px;
          }
          > div {
            position: relative;
            flex-shrink: 0;
            background-repeat: no-repeat !important;
            background-size: cover !important;
            border-radius: 10px;
            width: calc((15vh - 40px) * 314 / 198);
            height: 100%;
            display: flex;
            justify-content: center;
            align-items: center;
            > span {
              font-size: 28px;
              color: white;
              border-radius: 50%;
              border: solid 2px white;
              display: block;
              width: 42px;
              height: 42px;
              display: flex;
              justify-content: center;
              align-items: center;
              z-index: 100;
            }
            .icon-video-play {
              width: 35px;
              height: 35px;
              position: absolute;
              display: flex;
              justify-content: center;
              align-items: center;
              > div {
                width: 100%;
                height: 100%;
                border-radius: 50%;
                background: rgba($color: #000000, $alpha: 0.6);
              }
              img {
                position: absolute;
                width: 100%;
              }
            }
          }
        }
      }
    }
    #referral-icon {
      z-index: 150
    }
    .loading-apply-status {
      .rect-loading {
        position: absolute;
      }
    }
    .view-rules-popup {
      .full-image {
        height: 90% !important;
        .main {
          margin-top: 10%;
        }
      }
      .close-btn {
        color: var(--custom-color) !important;
      }
    }

  ::v-deep #btnDialogToggle {
    left: 50%;
    transform: translate(67px, 0);
  }
  ::v-deep .preview-group-plane {
    .preview-video {
      .icomoon-triangle {
        position: absolute;
        top: 50%;
        left: 50%;
        width: 60px;
        height: 60px;
        margin-top: -30px;
        margin-left: -30px;
        padding-left: 20px;
        border-radius: 50%;
        line-height: 60px;
        font-size: 30px;
        background-color: rgba(0, 0, 0, .5);
        color: #fff;
        box-sizing: border-box;
        text-align: inherit;
      }
    }

    .big-text-container {
      .more-text-video {
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 3;
        overflow: hidden;
      }
    }

    .preview-group {
      p {
        font-size: 13px;
      }

      span {
        font-size: 13px;
      }
    }
  }
}
</style>
<style lang="scss">
.light-header {
  .navigation-item {
    font-size: 14px;

    .user-name {
      font-size: 14px;
    }

    .dropdown-icon {
      font-size: 14px;
    }

    .dropdown-list {
      .dropdown-item {
        > span {
          font-size: 14px;
        }
      }
    }
  }
}
</style>
